<template>
  <div class="cover">
    <div class="cover__bg-video-wrapper">
      <video class="cover__bg-video" :src="bgVideo" muted plays-inline autoplay></video>
    </div>
    <div class="cover__innerwrap">
      <div class="cover__content-wrap">
        <h1 class="cover__title" v-html="page.title"></h1>
      </div>
    </div>
    <router-link class="cover__link-overlay" to="/welcome"></router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Cover',
  computed: {
    ...mapState(['pages']),
    page() {
      return this.pages.cover;
    },
    bgVideo() {
      return `static/${this.page.bg_video}`;
    },
  },
};
</script>

<style lang="scss">
@import '../styles/helpers';

.cover {
  @include section;
  height: 100vh;
  position: relative;
  overflow: hidden;

  &__link-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &__bg-video-wrapper {
    @include aspect-ratio-box-cover;
    z-index: -1;
  }

  &__bg-video {
    width: 100%;
    height: 100%;
    display: block;
  }

  &__content-wrap {
    width: 7/12 * 100%;
  }

  &__title {
    @include font-heading;
    position: relative;

    &::after {
      content: '';
      display: block;
      top: calc(100% + 20px);
      left: calc(14% - 20px);
      right: 20px;
      width: 86%;
      padding-top: 35.1% * 0.86;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('../assets/cover_arrow.svg');
      position: absolute;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Cover.vue